import { BoardValue } from '../../jscaip/AI/BoardValue';
import { PlayerMetricHeuristicWithBounds } from '../../jscaip/AI/Minimax';
import { DvonnRules } from './DvonnRules';
export class DvonnScoreHeuristic extends PlayerMetricHeuristicWithBounds {
    getMetrics(node, _config) {
        // The metric the total number of pieces controlled by a player
        return DvonnRules.getScores(node.gameState).toTable();
    }
    // Min/max value: all pieces are controlled by one. There are 49 pieces
    getBounds(_config) {
        const numberOfPieces = 49;
        return {
            player0Best: BoardValue.ofSingle(numberOfPieces, 0),
            player1Best: BoardValue.ofSingle(0, numberOfPieces),
        };
    }
}
